import { Selection } from 'src/projects/types/Selection';
import { BelimoTranslate } from 'src/common/hooks/useBelimoTranslate.ts';
import { UserSettings } from 'src/types/UserSettings.ts';
import { readSearchParam } from 'src/common/readSearchParam.ts';
import { LOCATION_STORE_PARAM_NAME } from 'src/common/constants.ts';
import {
    initLocationState as valvesInit,
    isLocationState as valvesValidator,
} from 'src/modules/locationStateContext.ts';
import {
    initLocationState as actuatorsInit,
    isLocationState as actuatorsValidator,
} from 'src/actuators/locationStateContext.ts';
import {
    initLocationState as sensorsInit,
    isLocationState as sensorsValidator,
} from 'src/sensors/locationStateContext.ts';

export const prepareForCart = ({
    selections,
    translate,
}: {
    selections: Selection[];
    translate: BelimoTranslate;
    userSettings: UserSettings;
}) => selections.reduce((acc, selection) => {
    if (selection.type === 'valves') {
        const locationState = readSearchParam(
            new URLSearchParams(selection.searchQuery),
            LOCATION_STORE_PARAM_NAME,
            { ...valvesInit },
            valvesValidator,
        );
        if (locationState.combo === null) {
            return acc;
        }

        const comboLabel = locationState.combo.valve === locationState.combo.actuator
            ? locationState.combo.valve
            : `${locationState.combo.valve}${locationState.combo.mounted ? '+' : '/'}${
                locationState.combo.actuator
            }`;
        acc.push({
            label: comboLabel,
            qty: locationState.combo.qty,
            content: selection.content.map((v) => (typeof v !== 'string' ? translate(v.key, v.detectNamespace) : v))
                .join(''),
        });
        locationState.selectedAccessories.forEach((item) => {
            acc.push(item);
        });
    }
    if (selection.type === 'actuators') {
        const locationState = readSearchParam(
            new URLSearchParams(selection.searchQuery),
            LOCATION_STORE_PARAM_NAME,
            { ...actuatorsInit },
            actuatorsValidator,
        );
        acc.push({
            label: locationState.actuatorLabel,
            qty: locationState.qty,
            content: selection.content.map((v) => (typeof v !== 'string' ? translate(v.key, v.detectNamespace) : v))
                .join(''),
        });
        locationState.selectedAccessories.forEach((item) => {
            acc.push(item);
        });
    }
    if (selection.type === 'sensors') {
        const locationState = readSearchParam(
            new URLSearchParams(selection.searchQuery),
            LOCATION_STORE_PARAM_NAME,
            { ...sensorsInit },
            sensorsValidator,
        );
        acc.push({
            label: locationState.sensorLabel,
            qty: locationState.qty,
        });
        locationState.selectedAccessories.forEach((item) => {
            acc.push(item);
        });
    }
    if (selection.type === 'retrofit_actuators') {
        acc.push({
            label: selection.productLabel,
            qty: selection.qty,
        });
        selection.selectedAccessories.forEach((item) => {
            acc.push(item);
        });
    }
    if (selection.type === 'retrofit_valves') {
        acc.push({
            label: selection.productLabel,
            qty: selection.qty,
        });
        selection.selectedAccessories.forEach((item) => {
            acc.push(item);
        });
    }
    if (selection.type === 'retrofit_sensors') {
        acc.push({
            label: selection.productLabel,
            qty: selection.qty,
        });
        selection.selectedAccessories.forEach((item) => {
            acc.push(item);
        });
    }
    return acc;
}, [] as { label: string; qty: number; content?: string }[]);
